import React from "react";
import AdminShell from "@/pages/admin/AdminShell";
import WhatsAppPendingBoard from "@/components/admin/WhatsAppPendingBoard";

/**
 * /admin/whatsapp-pendientes (admin-only route) — recovery de envíos
 * WhatsApp sin resolver (WACO Fase 1.2). Página deliberadamente mínima:
 * la lógica vive en WhatsAppPendingBoard; el backend re-valida el rol
 * en cada endpoint (require_roles() = solo admin).
 */
export default function WhatsAppPendingPage() {
  return (
    <AdminShell>
      <WhatsAppPendingBoard />
    </AdminShell>
  );
}
